import React from 'react'
import { SearchParams } from '../types'

interface HeaderProps {
  searchParams: SearchParams
  setSearchParams: (params: SearchParams) => void
  user?: any
  onLogout?: () => void
}

const Header: React.FC<HeaderProps> = ({ searchParams, setSearchParams, user, onLogout }) => {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-8">
            <h1 className="text-2xl font-bold text-red-500">XeniosDeals</h1>
            <nav className="hidden md:flex space-x-6">
              <a href="/" className="text-gray-600 hover:text-gray-900">Home</a>
              <a href="/search" className="text-gray-600 hover:text-gray-900">Explore</a>
              {user?.role === 'HOST' && (
                <a href="/host/dashboard" className="text-gray-600 hover:text-gray-900">Host Dashboard</a>
              )}
              {!user && (
                <a href="#" className="text-gray-600 hover:text-gray-900">Become a Host</a>
              )}
            </nav>
          </div>
          
          <div className="flex items-center space-x-4">
            {user ? (
              <>
                <span className="text-gray-700">Welcome, {user.first_name}!</span>
                {user.role === 'HOST' && (
                  <a href="/host/dashboard" className="text-gray-600 hover:text-gray-900">
                    Dashboard
                  </a>
                )}
                <button 
                  onClick={onLogout}
                  className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <a href="/help" className="text-gray-600 hover:text-gray-900">Help</a>
                <a href="/register" className="text-gray-600 hover:text-gray-900">Sign up</a>
                <a href="/login" className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600">
                  Log in
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
